function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  stroke: "#1CA6FF",
  strokeWidth: 2.053
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1CA6FF",
  stroke: "#1CA6FF",
  strokeWidth: 0.1,
  d: "M33.56 22.96c.573 0 1.04.467 1.04 1.04 0 5.736-4.664 10.4-10.4 10.4a10.371 10.371 0 0 1-7.358-3.05l-1.071 1.513a.415.415 0 0 1-.709-.295l-.222-3.994c0-.234.188-.418.418-.418l4.032-.29c.373 0 .557.445.295.708L18.32 29.88a8.266 8.266 0 0 0 5.88 2.44c4.586 0 8.32-3.734 8.32-8.32 0-.573.467-1.04 1.04-1.04zM15.88 24c0 .573-.467 1.04-1.04 1.04S13.8 24.573 13.8 24c0-5.736 4.664-10.4 10.4-10.4 2.768 0 5.4 1.114 7.35 3.054l1.306-1.528a.415.415 0 0 1 .708.295l.037 4.422a.417.417 0 0 1-.418.418h-3.997a.415.415 0 0 1-.295-.708l1.185-1.429A8.306 8.306 0 0 0 24.2 15.68c-4.586 0-8.32 3.734-8.32 8.32z"
}));

const SvgIcCloudSync = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcCloudSync, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-cloud-sync.ab215632.svg";
export { ForwardRef as ReactComponent };